import React from "react";
import { useNavigate } from "react-router";

interface IIndexServiceCardComponentProps {
    delay: number;
    subtitle: string;
    title: string;
    route: string;
    description: string;
    collg?: number;
    colmd?: number;
}

export const IndexServiceCardComponent: React.FC<
    IIndexServiceCardComponentProps
> = (props: IIndexServiceCardComponentProps) => {
    const { delay, subtitle, title, route, description, collg, colmd } = props;
    const navigate = useNavigate();

    return (
        <div
            className={`col-lg-${collg} col-md-${colmd}`}
            data-aos="fade-up"
            data-aos-delay={delay}
            style={{ cursor: "pointer" }}
            onClick={() => {
                navigate(route);
            }}
        >
            <div className="service-item  position-relative">
                <h5 className="fw-bold text-center">
                    {title}
                </h5>
                <p className="text-center">
                    {description?.length > 250
                        ? `${description.substring(0, 250)}...`
                        : description}
                </p>
            </div>
        </div>
    );
};
